import {ApiCacheEntry} from './types/ApiCacheEntry'

export default {
    api_cache: [] as ApiCacheEntry[]
}
